import { Box, Container, Heading, Body } from '@hover/blueprint';
import React from 'react';
import styled from '@emotion/styled';
import CaseStudiesSlideDesktop from './CaseStudiesSlideDesktop';
import CaseStudiesSlideMobile from './CaseStudiesSlideMobile';
import { SlickSliderContainer } from '../../ui';

const StyledSlider = styled(SlickSliderContainer)`
  @media (max-width: 834px) {
    .slick-dots {
      bottom: -50px;
    }
  }
`;

const settings = {
  dots: true,
  infinite: true,
  speed: 2500,
  autoplaySpeed: 10000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
};

const ExteriorContractorsCaseStudies: React.FC = () => (
  <Box
    width="100%"
    bg={{ base: 'neutral.0', desktop: 'brandNavy.100' }}
    pt={{ base: 700, desktop: 1000 }}
    pb={{ base: 0, desktop: '162px' }}
    borderRadius={{ base: '8px', tablet: 0 }}
    px={500}
  >
    <Container
      borderRadius={{ base: '8px', desktop: 0 }}
      pt={{ base: 700, desktop: 0 }}
      pb={{ base: 1000, tablet: 1100, desktop: 0 }}
      shadow={{ base: 'distance300', desktop: 'none' }}
      maxW="1200px"
      bg="brandNavy.100"
    >
      <Box
        mx={{ base: 'auto', desktop: 0 }}
        mb={{ base: 600, desktop: '112px' }}
        flexDir="column"
        maxW={{ base: 'xl', desktop: '100%' }}
      >
        <Box
          bg="brandNavy.500"
          w="120px"
          height="30px"
          alignItems="center"
          justifyContent="center"
          mb={600}
          borderRadius="8px"
        >
          <Body
            size={200}
            fontWeight={{ base: 500, desktop: 700 }}
            borderRadius={300}
            color="neutral.0"
          >
            CASE STUDIES
          </Body>
        </Box>
        <Heading size={{ base: 500, desktop: 700 }} style={{ marginBottom: 0 }}>
          Rapid Roofing More Than Doubled Their Close Rate With HOVER.
        </Heading>
      </Box>
      <Box d={{ base: 'none', desktop: 'block' }} w="100%">
        <SlickSliderContainer {...settings}>
          <CaseStudiesSlideDesktop />
        </SlickSliderContainer>
      </Box>
      <Box d={{ base: 'block', desktop: 'none' }} w="100%">
        <StyledSlider {...settings}>
          <CaseStudiesSlideMobile />
        </StyledSlider>
      </Box>
    </Container>
  </Box>
);

export default ExteriorContractorsCaseStudies;
